export default __webpack_public_path__ + "fa7214abc4899f3860264ad48e53174f.svg";